import { ArpMedia, ORDER } from '@arpeggi/shared'
import { useState } from 'react'
import { OrderBy } from '../../../__legacy__/components/platform/new-explore/hooks/useSounds'
import { IArpMedia } from '../../arp-registry/ArpMedia'

export const useMediaOrder = (data: IArpMedia[] | ArpMedia[]) => {
  const [order, setOrder] = useState<ORDER>('desc')
  const [orderBy, setOrderBy] = useState<OrderBy>('createdAt')
  const ordered = data.sort((a, b) => {
    const valueA = a[orderBy]
    const valueB = b[orderBy]
    if (typeof valueA === 'string') {
      return valueA.localeCompare(valueB)
    }
    return valueA - valueB
  })
  const reversed = order === 'desc' ? ordered : ordered.reverse()

  const handleOrderChange = (newOrderBy: OrderBy) => {
    if (newOrderBy === orderBy) return setOrder(order === 'asc' ? 'desc' : 'asc')
    setOrderBy(newOrderBy)
    setOrder('desc')
  }

  return { data: reversed, handleOrderChange, order, orderBy }
}
